import { atom } from 'recoil'

const PostsState = atom({
  key: 'PostsState',
  default: { data: [], totalPages: 0 }
})

export default PostsState
